import * as React from "react";
import {FC, useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {Grid, Tab, Tabs} from "@mui/material";
import {BrickShipping} from "../../BrickMailType";
import {FormInputText} from "../../../../shop/wholesale/form/FormInputText";
import {FormInputColor} from "../../../../shop/wholesale/form/FormInputColor";
import {FormInputSelect} from "../../../../shop/wholesale/form/FormInputSelect";
import {alignments} from "../../constants/MailConstants";

export const BrickShippingEditor: FC<{ brick: BrickShipping, onChange: (brick: BrickShipping) => void }> = ({
                                                                                                               brick,
                                                                                                               onChange
                                                                                                            }) => {
   const [tab, setTab] = useState<'content' | 'layoutText' | 'layoutButton' | 'options'>('content');
   const formContext = useFormContext<BrickShipping>();
   const {reset, control} = formContext;

   useEffect(() => {
      reset(brick)
   }, [brick, reset])

   return (
      <div>
         <Tabs value={tab}>
            <Tab value={'content'} label={"Content"} onClick={() => setTab("content")}/>
            <Tab value={'layoutText'} label={"Text Layout"} onClick={() => setTab("layoutText")}/>
            <Tab value={'layoutButton'} label={"Button Layout"} onClick={() => setTab("layoutButton")}/>
            <Tab value={'options'} label={"Options"} onClick={() => setTab("options")}/>
         </Tabs>

         {tab === 'content' && <Grid container spacing={"10px"}>
             <Grid item xs={12}>
                 <FormInputText name={"qrImageTitle"} control={control} label={"QR Image Title"}/>
             </Grid>
             <Grid item xs={12}>
                 <FormInputText name={"qrDownloadTitle"} control={control} label={"QR Download Title"}/>
             </Grid>
             <Grid item xs={12}>
                 <FormInputText name={"qrDownloadButtonTitle"} control={control} label={"QR Download Button Title"}/>
             </Grid>
             <Grid item xs={12}>
                 <FormInputText name={"shippingTitle"} control={control} label={"Shipping Title"}/>
             </Grid>
             <Grid item xs={12}>
                 <FormInputText name={"shippingButtonTitle"} control={control} label={"Shipping Button Title"}/>
             </Grid>
             <Grid item xs={12}>
                 <FormInputText name={"labelCodeTitle"} control={control} label={"Label Code Title"}/>
             </Grid>
         </Grid>}

         {tab === 'layoutText' && <Grid container spacing={"10px"}>
             <Grid item xs={6}>
                 <FormInputText name={"layoutText.fontSize"} control={control} label={"Font Size"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"layoutText.fontFamily"} control={control} label={"Font Family"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputColor name={"layoutText.color"} control={control} label={"Text Color"}
                                 defaultColor={"#000000"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputColor name={"layoutText.backgroundColor"} control={control} label={"Background Color"}
                                 defaultColor={"#ffffff"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"layoutText.margin"} control={control} label={"Margin"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"layoutText.align"} control={control} label={"Align (left, center, right)"}/>
             </Grid>
         </Grid>}

         {tab === 'layoutButton' && <Grid container spacing={"10px"}>
             <Grid item xs={4}>
                 <FormInputColor name={"layoutButton.color"} control={control} label={"Button Text Color"}
                                 defaultColor={"#FFFFFF"}/>
             </Grid>
             <Grid item xs={4}>
                 <FormInputColor name={"layoutButton.borderColor"} control={control} label={"Button Border Color"}
                                 defaultColor={"#993300"}/>
             </Grid>
             <Grid item xs={4}>
                 <FormInputColor name={"layoutButton.backgroundColor"} control={control}
                                 label={"Button Background Color"}
                                 defaultColor={"#993300"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"layoutButton.margin"} control={control} label={"Margin"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"layoutButton.fontFamily"} control={control} label={"Font"}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputSelect name={"layoutButton.align"} control={control} label={"Align"} options={alignments}/>
             </Grid>
         </Grid>}

         {tab === 'options' && <Grid container spacing={"10px"}>
             <Grid item xs={6}>
                 <FormInputSelect name={"align"} control={control} label={"Overall Align"} options={alignments}/>
             </Grid>
             <Grid item xs={6}>
                 <FormInputText name={"margin"} control={control} label={"Overall Margin"}/>
             </Grid>
             <Grid item xs={12}>
                <FormInputText name={"activation"} control={control} label={"Activation expression"}/>
             </Grid>
         </Grid>}
      </div>
   );
}